module.exports = __webpack_public_path__ + "69b671f6574f4b7c0411f9f156d7673c.MP3";